import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useSiteSettings } from '../lib/cmsStore';
export function Navigation() {
  const [isOpen, setIsOpen] = useState(false);
  const {
    data,
    isLoading
  } = useSiteSettings();
  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({
      behavior: 'smooth'
    });
    setIsOpen(false);
  };
  const logo = !isLoading && data?.logo ? data.logo : 'SINKA.';
  // Use sectionOrder from settings, fall back to default
  const navOrder = !isLoading && data?.sectionOrder?.length ? data.sectionOrder : ['work', 'about', 'music', 'experiments', 'writing', 'contact'];
  const defaultNavItems = navOrder.map(id => ({
    id,
    label: id
  }));
  // Map from settings or use defaults, then sort by navOrder
  const allNavItems = (!isLoading && data?.navLabels ? Object.entries(data.navLabels).map(([id, label]) => ({
    id,
    label
  })) : defaultNavItems).sort((a, b) => {
    const ai = navOrder.indexOf(a.id);
    const bi = navOrder.indexOf(b.id);
    return (ai === -1 ? 999 : ai) - (bi === -1 ? 999 : bi);
  });
  // Filter out hidden sections
  const navItems = allNavItems.filter(item => {
    if (!data?.sectionVisibility) return true;
    return data.sectionVisibility[item.id] !== false;
  });
  return <>
      <nav className="fixed left-0 right-0 z-50 mix-blend-difference" style={{
      top: 'var(--notification-bar-height, 0px)'
    }} data-id="element-276">
        <div className="flex items-center justify-between px-6 py-5 md:px-12" data-id="element-277">
          <button onClick={() => scrollTo('hero')} className="font-display text-lg font-bold tracking-tight text-foreground" data-id="element-278">
            {logo.replace('.', '')}
            <span className="text-primary" data-id="element-279">
              {logo.includes('.') ? '.' : ''}
            </span>
          </button>

          {/* Desktop nav */}
          <div className="hidden md:flex items-center gap-8" data-id="element-280">
            {navItems.map(item => <button key={item.id} onClick={() => scrollTo(item.id)} className="font-mono text-xs uppercase tracking-widest text-muted-foreground hover:text-primary transition-colors duration-300 border-b border-transparent hover:border-primary pb-1" data-id="element-281">
                {item.label}
              </button>)}
          </div>

          {/* Mobile toggle */}
          <button onClick={() => setIsOpen(!isOpen)} className="md:hidden flex flex-col gap-1.5 z-50" data-id="element-282">
            <motion.span animate={isOpen ? {
            rotate: 45,
            y: 6
          } : {
            rotate: 0,
            y: 0
          }} className="block w-6 h-[2px] bg-foreground" data-id="element-283" />
            <motion.span animate={isOpen ? {
            opacity: 0
          } : {
            opacity: 1
          }} className="block w-6 h-[2px] bg-foreground" data-id="element-284" />
            <motion.span animate={isOpen ? {
            rotate: -45,
            y: -6
          } : {
            rotate: 0,
            y: 0
          }} className="block w-6 h-[2px] bg-foreground" data-id="element-285" />
          </button>
        </div>
      </nav>

      {/* Mobile menu */}
      <AnimatePresence data-id="element-286">
        {isOpen && <motion.div initial={{
        x: '100%'
      }} animate={{
        x: 0
      }} exit={{
        x: '100%'
      }} transition={{
        type: 'tween',
        duration: 0.3
      }} className="fixed inset-0 z-40 bg-background/95 backdrop-blur-lg flex flex-col items-center justify-center gap-8" data-id="element-287">
            {navItems.map((item, i) => <motion.button key={item.id} initial={{
          opacity: 0,
          x: 50
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: i * 0.1
        }} onClick={() => scrollTo(item.id)} className="font-display text-3xl font-bold uppercase tracking-tight text-foreground hover:text-primary transition-colors" data-id="element-288">
                {item.label}
              </motion.button>)}
          </motion.div>}
      </AnimatePresence>
    </>;
}